import { render, staticRenderFns } from "./recorrectUnionAPMsg.vue?vue&type=template&id=c6ce9716&scoped=true&"
import script from "./recorrectUnionAPMsg.vue?vue&type=script&lang=js&"
export * from "./recorrectUnionAPMsg.vue?vue&type=script&lang=js&"
import style0 from "./recorrectUnionAPMsg.vue?vue&type=style&index=0&id=c6ce9716&lang=less&scoped=true&"
import style1 from "./recorrectUnionAPMsg.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ce9716",
  null
  
)

component.options.__file = "recorrectUnionAPMsg.vue"
export default component.exports